<template>
  <div
    class="detail-awards"
    data-cy="awards"
  >
    <UnderlinedTitle
      tag="h2"
      tag-class="h5"
      :title="$t('awards.title')"
    />
    <div class="awards-container">
      <ul class="m-awards-list">
        <li
          v-for="(award, i) in awards"
          :key="i"
        >
          <span class="uppercase">{{ award.name }}</span>
          <span v-if="award.event">{{ award.event }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import UnderlinedTitle from '@components/UnderlinedTitle'
import { mapGetters } from 'vuex'
import { dateIntervalFormatting } from '@helpers/date'

export default {
  name: 'DetailAwards',
  components: {
    UnderlinedTitle
  },
  props: {
    awards: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      locale: 'Global/locale'
    })
  },
  methods: {
    awardDateFormat: function (award) {
      return dateIntervalFormatting(award.start_date, award.end_date, this.locale)
    }
  }
}
</script>

<style lang="less" scoped>
@import (reference) "~@less/shared/utilities.less";

.awards-container {
  .small-box-vertical-margin;

  .m-awards-list {
    li {
      .small-box-vertical-margin;
      span {
        font-family: @font-family-sans-serif;
        display: block;
      }
    }

  }
}
</style>
